import { render } from "./portrait.vue?vue&type=template&id=040899b0&lang=html"
import script from "./portrait.vue?vue&type=script&lang=js"
export * from "./portrait.vue?vue&type=script&lang=js"

import "./portrait.vue?vue&type=style&index=0&id=040899b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__